import RoutesWrapper from "./routes";

function App() {
  return <RoutesWrapper />;
} 

export default App;
